import type { Mesh, Object3D, Vector3 } from '@anov/3d-core'
import { Color, ShaderMaterial, use } from '@anov/3d-core'
import { createRoundLineWallMesh, createRoundedClosedWallMesh } from '../../Utils/round-curve'
import type { FenceOption } from '../type'
import { hexToRGBA, parseRGBA } from '../tool'
import FenceBase from './FenceBase'

class Fence_Roll_01 extends FenceBase {
  constructor(option: FenceOption, areaInstance: Object3D) {
    super(option, areaInstance)
    this.create()
  }

  create() {
    this._mesh = this.createFenceMesh(
      this._points,
      this._corner,
      this._close,
      this._height,
      this._color,
      this._alpha,
    )
    this._mesh && this.add(this._mesh)
  }

  // 创建围栏网格对象
  createFenceMesh(points: Vector3[], radius = 0, close = true, height: number, color: string, alpha: number) {
    if (!points)
      return
    // 创建围栏使用的材质，调用createFenceMaterial方法生成ShaderMaterial类型的材质
    const material = this.createFenceMaterial(height, color, alpha)

    // 使用createRoundLineWallMesh函数创建围栏的网格物体，传入点数组、半径、高度、是否闭合等参数以及创建好的材质
    const mesh = createRoundedClosedWallMesh(
      points,
      {
        radius,
        height,
        close,
      },
      material,
    )
    // const mesh = createRoundLineWallMesh(
    //   points,
    //   {
    //     radius,
    //     height,
    //     close,
    //   },
    //   material,
    // )
    use.useframe(this.sceneControl, () => {
      // mesh.children.forEach((item, index) => {
      //   const uniforms = ((item as Mesh).material as ShaderMaterial).uniforms
      //   uniforms.iTime.value += 0.01
      // })

      const uniforms = ((mesh as Mesh).material as ShaderMaterial).uniforms
      uniforms.iTime.value += 0.002
    })

    // // 创建围栏使用的材质，调用createFenceMaterial方法生成ShaderMaterial类型的材质
    // const material = this.createFenceMaterial(height, color, alpha)
    // // 使用createRoundLineWallMesh函数创建围栏的网格物体，传入点数组、半径、高度、是否闭合等参数以及创建好的材质
    // const mesh = createRoundLineWallMesh(
    //   points,
    //   {
    //     radius,
    //     height,
    //     close,
    //   },
    //   material,
    // )
    // use.useframe(() => {
    //   mesh.children.forEach((item, index) => {
    //     const uniforms = ((item as Mesh).material as ShaderMaterial).uniforms
    //     uniforms.iTime.value += 0.002
    //   })
    // })
    return mesh
  }

  // 创建围栏材质
  createFenceMaterial(height: number, color: string, alpha: number): ShaderMaterial {
    const { r, g, b } = parseRGBA(hexToRGBA(color))
    const colorTemp = { r: Number((Number(r) / 255).toFixed(4)), g: Number((Number(g) / 255).toFixed(4)), b: Number((Number(b) / 255).toFixed(4)) }
    // 创建一个ShaderMaterial实例，用于自定义围栏的渲染效果
    const material = new ShaderMaterial({
      uniforms: {
        // 材质颜色
        color1: {
          value: colorTemp,
        }, // 材质颜色2，用于渐变
        _alpha: { value: alpha },
        _height: { value: height },
        iTime: { value: 0.0 },
      },
      // 顶点着色器
      vertexShader: `
         #include <common>
            #include <logdepthbuf_pars_vertex>
            varying vec3 vNormal; // 用于传递法线方向
            varying vec2 vUv;
            varying vec3 vWorldPosition;
          void main() {
            	#include <begin_vertex>
            #include <project_vertex>
            #include <logdepthbuf_vertex>
            // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
          vUv = uv;
          vNormal = normalize(mat3(modelMatrix) * normal);  // 使用模型矩阵旋转法线
          vec4 modelPosition = modelMatrix * vec4(position, 1.0);
          vWorldPosition = modelPosition.xyz;
          gl_Position = projectionMatrix * viewMatrix * modelPosition;
          }
      `,
      // 片元着色器
      fragmentShader: `
             #include <common>
         #include <logdepthbuf_pars_fragment>
         varying vec3 vNormal; //
         varying vec2 vUv;
         varying vec3 vWorldPosition;
        // uniform float button;
         uniform float _height;
         uniform float iTime;
         uniform float _alpha;
        uniform vec3 color1;
       
        void main() {
        #include <logdepthbuf_fragment>
       // float height = 50.;
        float button = 0.;
        vec3 myWp=(vWorldPosition-button)/_height;       
        vec3 myWp_s=(vWorldPosition-button)*3./_height;  
        float Grandient= pow(1.-clamp(myWp.y,0.,1.),1.5);    
        float Grandient_s= pow(1.-fract(myWp_s.y-iTime),0.4);    
           gl_FragColor = vec4(color1,Grandient*Grandient_s*(0.8+sin(iTime*5.0)*0.3) )  *_alpha       *step(button,myWp.y);
           
        }
      `,
      // 设置材质为透明
      transparent: true,
      // 设置材质双面渲染，确保从正反两面都能正确显示
      side: 2,
      // 关闭深度测试
      depthTest: true,
      depthWrite: false,
    })
    return material
  }
}

export default Fence_Roll_01
